export class CompaniesResponse {
  _id: string = "";
  name: string = "";
  created_at: string = "";
  updated_at: string = "";
  status: number = 0;
  phone: string = "";
  description: string = "";
  address: string = "";
  normalized_value: string = "";

  constructor(data?: Partial<CompaniesResponse>) {
    Object.assign(this, data);
  }
}
